import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { DataStore } from 'aws-amplify';
import { UserGroup, AppUser, Farm, Photo, UserType } from '../../models';
import { AntDesign, Entypo, MaterialIcons, FontAwesome } from '@expo/vector-icons';
import * as CmnUtil from '../../components/CmnUtil';
import * as AppConst from '../../components/AppConst';

/** ================================
*  ダッシュボード画面
*  ================================*/
const Dashboard = () => {
  // 各種情報
  const [userGroupCnt, setUserGroup] = useState('');
  const [producerCnt, setProducerCnt] = useState('');
  const [instructorCnt, setInstructorCnt] = useState('');
  const [farmCnt, setFarmCnt] = useState('');
  const [photoCnt, setPhotoCnt] = useState('');

  const iconSize = 24;

  useEffect(() => {
    // 最新情報取得
    updateUserGroup();
    updateAppUser();
    updateFarm();
    updatePhoto();

    // 購読開始
    const observeUserGroup = DataStore.observe(UserGroup).subscribe(updateUserGroup);
    const observeAppUser = DataStore.observe(AppUser).subscribe(updateAppUser);
    const observeFarm = DataStore.observe(Farm).subscribe(updateFarm);
    const observePhoto = DataStore.observe(Photo).subscribe(updatePhoto);

    // 画面破棄時に購読終了
    return () => {
      observeUserGroup.unsubscribe();
      observeAppUser.unsubscribe();
      observeFarm.unsubscribe();
      observePhoto.unsubscribe();
    }
  }, []);

  const updateUserGroup = async () => {
    // 組織数
    const userGroup = (await DataStore.query(UserGroup, c => c.or(c => c.groupType('eq', UserType.PRODUCER).groupType('eq', UserType.INSTRUCTOR))));
    setUserGroup(userGroup.length.toString());
  }

  const updateAppUser = async () => {
    // 生産者数
    const producer = (await DataStore.query(AppUser, c => c.type('eq', UserType.PRODUCER)));
    setProducerCnt(producer.length.toString());

    // 普及指導員数
    const instructor = (await DataStore.query(AppUser, c => c.type('eq', UserType.INSTRUCTOR)));
    setInstructorCnt(instructor.length.toString());
  }

  const updateFarm = async () => {
    // 圃場総数
    const farm = (await DataStore.query(Farm));
    setFarmCnt(farm.length.toString());
  }

  const updatePhoto = async () => {
    // 今日の撮影枚数
    const photo = (await DataStore.query(Photo, c => c.takenAt('beginsWith', CmnUtil.getDate())));
    setPhotoCnt(photo.length.toString());
  }

  // カード表示
  const CardView = ({ icon, title, cnt }: { icon: Function, title: string, cnt: string }) => {
    return (
      <View style={styles.cardOutline}>
        <View style={styles.cardHeader}>
          {icon()}
          <Text style={[{ marginLeft: 10, color: AppConst.defaultTextColor }, AppConst.styles.fontSizeL]}>{title}</Text>
        </View>
        <View style={styles.cardContent}>
          <Text style={AppConst.styles.fontSizeLL}>{cnt}</Text>
        </View>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <View style={{ flexDirection: 'row' }}>
        <CardView title='組織数' cnt={userGroupCnt} icon={() => (<FontAwesome name='group' color={AppConst.defaultTextColor} size={iconSize} />)} />
        <CardView title='生産者数' cnt={producerCnt} icon={() => (<AntDesign name='user' color={AppConst.defaultTextColor} size={iconSize} />)} />
        <CardView title='普及指導員数' cnt={instructorCnt} icon={() => (<Entypo name='user' color={AppConst.defaultTextColor} size={iconSize} />)} />
      </View>
      <View style={{ flexDirection: 'row' }}>
        <CardView title='圃場総数' cnt={farmCnt} icon={() => (<MaterialIcons name='place' color={AppConst.defaultTextColor} size={iconSize} />)} />
        <CardView title='今日の撮影枚数' cnt={photoCnt} icon={() => (<AntDesign name='picture' color={AppConst.defaultTextColor} size={iconSize} />)} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
  },
  cardOutline: {
    margin: 10,
    shadowColor: 'black',
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.4,
  },
  cardHeader: {
    flexDirection: 'row',
    width: 300,
    height: 50,
    paddingLeft: 10,
    backgroundColor: AppConst.defaultColor,
    alignItems: 'center',
  },
  cardContent: {
    height: 100,
    backgroundColor: AppConst.defaultBaseInputColor,
    alignItems: 'center',
    justifyContent: 'center'
  },
});

export default Dashboard;
